import React from 'react'
import { Stack, Skeleton, Box } from '@mui/material'

const CardSkeleton: React.FC = () => {
  const getRandomWidth = () => Math.floor(Math.random() * (180 - 80 + 1) + 80)

  return (
    <Stack sx={{ height: '100%', maxHeight: '90vh' }}>
      <Stack 
        direction="row" 
        alignItems="center" 
        justifyContent="space-between"
        sx={{ px: 3, pt: 3, pb: 2 }}
      >
        <Stack direction="row" gap={1.5}>
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="circular" width={24} height={24} />
        </Stack>
        <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: '50px' }} />
        <Skeleton variant="circular" width={24} height={24} />
      </Stack>

      <Stack gap={2} alignItems="center" sx={{ px: 3 }}>
        <Skeleton variant="text" width={300} height={32} />

        <Skeleton variant="rounded" width="100%" height={36} sx={{ borderRadius: '8px' }} />
      </Stack>

      <Box 
        sx={{ 
          px: 3,
          pb: 3,
          pt: 3,
          overflowY: 'auto',
          flex: 1
        }}
      >
        <Stack gap={2}>
          <Stack 
            sx={{ 
              borderRadius: '8px', 
              pt: 2,
              pb: 1,
              px: 2,
              gap: 2
            }}
          >
            <Stack direction="row" gap={1} alignItems="center" justifyContent="center">
              <Skeleton variant="text" width={150} height={20} />
            </Stack>
            <Stack direction="row" gap={1} alignItems="center" justifyContent="center">
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="rounded" width={200} height={32} sx={{ borderRadius: '8px' }} />
            </Stack>
          </Stack>

          <Stack direction="row" gap={1} justifyContent="center">
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="circular" width={24} height={24} />
          </Stack>

          <Stack sx={{ mt: 1 }}>
            {[1, 2, 3, 4, 5, 6, 7].map((i) => (
              <Stack 
                key={i}
                direction="row"
                sx={{
                  py: 1,
                  px: 2,
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Skeleton variant="text" width={getRandomWidth()} height={20} />
                <Skeleton variant="text" width={150} height={20} />
              </Stack>
            ))}
          </Stack>
        </Stack>
      </Box>
    </Stack>
  )
}

export default CardSkeleton